import { render } from "./PRD.vue?vue&type=template&id=40fe536a&scoped=true"
import script from "./PRD.vue?vue&type=script&lang=js"
export * from "./PRD.vue?vue&type=script&lang=js"

import "./PRD.vue?vue&type=style&index=0&id=40fe536a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fe536a"]])

export default __exports__